import { defineAsyncComponent } from 'vue'
export default {
  "auth-login": defineAsyncComponent(() => import("/app/layouts/auth-login.vue").then(m => m.default || m)),
  auth: defineAsyncComponent(() => import("/app/layouts/auth.vue").then(m => m.default || m)),
  default: defineAsyncComponent(() => import("/app/layouts/default.vue").then(m => m.default || m)),
  patient: defineAsyncComponent(() => import("/app/layouts/patient.vue").then(m => m.default || m))
}